export default "__VITE_ASSET__C1u22NjG__"